/*
 * Copyright (c) 2022 Puratos. All rights reserved.
 */

export enum SkeletonSettings {
    FOREGROUND = "#ecebeb",
    BACKGROUND = "#cfcfcf",
    BORDER = "1px solid #cfcfcf",
    SPEED = 2
}
